<template>
  <Background>
    <div class="image-wrapper">
      <img
        src="@/assets/header/KEMPEN.png"
        alt=" KEMPEN"
        class="pbt-image"
      >
      <div class="line-under-image" />
    </div>

    <!-- Campaign Section -->
    <div class="content-wrapper">
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="items"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div>
      </div>

      <!-- Displaying jumlahData dynamically -->
      <div class="jumlah">
        <div
          v-for="(jumlah, index) in jumlahData"
          :key="index"
          class="jumlah-container"
        >
          <img
            src="@/assets/spah/box.png"
            :alt="jumlah.altText"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>{{ jumlah.title }}</h3>
              <p class="number">
                {{ jumlah.count }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
      
    <div class="content-wrapper">
      <div
        v-for="(campaign, index) in campaigns"
        :key="index"
        class="campaign-section"
      >
        <h2>{{ campaign.title }}</h2>

        <!-- Row for campaign data -->
        <div class="campaign-row">
          <!-- SASARAN KEMPEN Column -->
          <div class="campaign-column saran-kempen">
            <p><strong>SASARAN KEMPEN :</strong></p>
            <p>{{ campaign.sasaran }}</p>
          </div>

          <!-- JUMLAH LOKALITI PELAKSANAAN Column -->
          <div class="campaign-column pelaksanaan">
            <p><strong>JUMLAH LOKALITI PELAKSANAAN</strong></p>
            <p class="count">
              {{ campaign.pelaksanaan }}
            </p>
          </div>

          <!-- JUMLAH LOKALITI MENCAPAI SASARAN Column -->
          <div class="campaign-column mencapai-sasaran">
            <p><strong>JUMLAH LOKALITI MENCAPAI SASARAN</strong></p>
            <p class="count">
              {{ campaign.mencapaiSasaran }}
            </p>
          </div>
        </div>
      </div>
    </div>

     <Menu />

  </Background>
</template>



<script setup>
import Menu from '@/components/menu-items/utama-menu.vue'

import { computed, ref } from 'vue'


const items = ['2021', '2022', '2023', '2024'] // Dropdown items for years
const selectedYear = ref('2024') // Default selected year


//added by abdullah 
definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})

// Data for 2021 and 2022
const jumlahData2021 = [
  { title: 'Jumlah Siri Kempen Dilaksanakan', count: '4', altText: 'First Image' },
  { title: 'Jumlah Lokaliti Kempen', count: '156', altText: 'Second Image' },
]

const jumlahData2022 = [
  { title: 'Jumlah Siri Kempen Dilaksanakan', count: '5', altText: 'First Image' },
  { title: 'Jumlah Lokaliti Kempen', count: '125', altText: 'Second Image' },
]

const jumlahData2023 = [
  { title: 'Jumlah Siri Kempen Dilaksanakan', count: '5', altText: 'First Image' },
  { title: 'Jumlah Lokaliti Kempen', count: '78', altText: 'Second Image' },
]

const jumlahData2024 = [
  { title: 'Jumlah Siri Kempen Dilaksanakan', count: '7', altText: 'First Image' },
  { title: 'Jumlah Lokaliti Kempen', count: '80', altText: 'Second Image' },
]


const campaigns2021 = [
  {
    title: 'Kempen Membasmi Wabak Dan Hotspot Denggi PBT',
    sasaran: 'Wabak Tamat / Tiada Kes Denggi',
    pelaksanaan: 39,
    mencapaiSasaran: 39,
  },
  {
    title: 'Kempen Premis Makanan Bersih PBT',
    sasaran: 'Premis Makanan Mencapai Gred B Dan Ke Atas',
    pelaksanaan: 39,
    mencapaiSasaran: 39,
  },
  {
    title: 'Kempen Tandas Awam Bersih PBT',
    sasaran: 'Tandas Awam Mencapai Penarafan 4 Bintang Dan Ke Atas',
    pelaksanaan: 39,
    mencapaiSasaran: 39,
  },
  {
    title: 'Kempen Pasar Awam Bersih PBT',
    sasaran: 'Pasar Awam Mencapai Kebersihan Gred B Dan Ke Atas',
    pelaksanaan: 39,
    mencapaiSasaran: 32,
  },
]

const campaigns2022 = [
  {
    title: 'Kempen Membasmi Wabak Dan Hotspot Denggi PBT',
    sasaran: 'Wabak Tamat / Tiada Kes Denggi',
    pelaksanaan: 25,
    mencapaiSasaran: 25,
  },
  {
    title: 'Kempen Membasmi Tikus PBT',
    sasaran: 'Indeks Tikus ≤ 1 (Rendah)',
    pelaksanaan: 25,
    mencapaiSasaran: 25,
  },
  {
    title: 'Kempen Premis Makanan Bersih PBT',
    sasaran: 'Premis Makanan Mencapai Gred B Dan Ke Atas',
    pelaksanaan: 25,
    mencapaiSasaran: 25,
  },
  {
    title: 'Kempen Tandas Awam Bersih PBT',
    sasaran: 'Tandas Awam Mencapai Penarafan 4 Bintang Dan Ke Atas',
    pelaksanaan: 25,
    mencapaiSasaran: 25,
  },
  {
    title: 'Kempen Pasar Awam Bersih PBT',
    sasaran: 'Pasar Awam Mencapai Kebersihan Gred B Dan Ke Atas',
    pelaksanaan: 25,
    mencapaiSasaran: 25,
  },
]

const campaigns2023 = [
  {
    title: 'Kempen Membasmi Wabak Dan Hotspot Denggi PBT',
    sasaran: 'Wabak Tamat / Tiada Kes Denggi',
    pelaksanaan: 12,
    mencapaiSasaran: 12,
  },
  {
    title: 'Kempen Membasmi Tikus PBT',
    sasaran: 'Indeks Tikus ≤ 1 (Rendah)',
    pelaksanaan: 12,
    mencapaiSasaran: 12,
  },
  {
    title: 'Kempen Premis Makanan Bersih PBT',
    sasaran: 'Premis Makanan Mencapai Gred B Dan Ke Atas',
    pelaksanaan: 12,
    mencapaiSasaran: 12,
  },
  {
    title: 'Kempen Tandas Awam Bersih PBT',
    sasaran: 'Tandas Awam Mencapai Penarafan 4 Bintang Dan Ke Atas',
    pelaksanaan: 30,
    mencapaiSasaran: 30,
  },
  {
    title: 'Kempen Pasar Awam Bersih PBT',
    sasaran: 'Pasar Awam Mencapai Kebersihan Gred B Dan Ke Atas',
    pelaksanaan: 12,
    mencapaiSasaran: 12,
  },
]

const campaigns2024 = [
  {
    title: 'Kempen Membasmi Wabak Denggi',
    sasaran: 'Wabak Tamat / Tiada Kes Denggi',
    pelaksanaan: 12,
    mencapaiSasaran: 12,
  },
  {
    title: 'Kempen Membasmi Hotspot Denggi PBT',
    sasaran: 'Wabak Tamat / Tiada Kes Denggi',
    pelaksanaan: 10,
    mencapaiSasaran: 10,
  },
  {
    title: 'Kempen Membasmi Infestasi Tikus',
    sasaran: 'Indeks Tikus ≤ 1 (Rendah)',
    pelaksanaan: 12,
    mencapaiSasaran: 12,
  },
  {
    title: 'Kempen Premis Makanan Bersih PBT',
    sasaran: 'Premis Makanan Mencapai Gred B Dan Ke Atas',
    pelaksanaan: 12,
    mencapaiSasaran: 12,
  },
  {
    title: 'Kempen Pasar Awam Bersih PBT',
    sasaran: 'Pasar Awam Mencapai Kebersihan Gred B Dan Ke Atas',
    pelaksanaan: 10,
    mencapaiSasaran: 10,
  },
  {
    title: 'Kempen Tandas Awam Bersih BMW',
    sasaran: 'Tandas Awam Mencapai Penarafan 4 Bintang Dan Ke Atas',
    pelaksanaan: 10,
    mencapaiSasaran: 10,
  },
  {
    title: 'Kempen Pengurusan Haiwan Terbiar',
    sasaran: 'Peningkatan Pelesenan Anjing',
    pelaksanaan: 12,
    mencapaiSasaran: 12,
  },

]

// Computed properties to select data based on the selected year
const jumlahData = computed(() => {
  switch (selectedYear.value) {
  case '2021':
    return jumlahData2021
  case '2022':
    return jumlahData2022
  case '2023':
    return jumlahData2023
  case '2024':
    return jumlahData2024
  default:
    return []
  }
})

const campaigns = computed(() => {
  switch (selectedYear.value) {
    case '2021':
      return campaigns2021
    case '2022':
      return campaigns2022
    case '2023':
      return campaigns2023
    case '2024':
      return campaigns2024
    default:
      return []
  }
})
</script>

<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1200px;
  padding: 20px;
  background-color: rgba(255, 255, 255, 65%); /* Background for content */
  border-radius: 20px; /* Rounded corners */
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.2); /* Shadow for depth */
  margin: 20px 0;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  max-width: 70%; /* Adjusted size */
  height: auto;
}

.line-under-image {
  width: 70%; /* Match width to the image size */
  height: 5px;
  background-color: white;
  border-radius: 5px;
  margin-top: 10px;
}

h2 {
  color: rgb(21,0,105);
  font-size: 1.5rem; 
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 10px; 
  text-align: left; 
  width: 100%;
}


/* Flexbox container for the input fields */
.input-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

/* Styles for each input field */
.input-item {
  flex: 1;
  margin-right: 15px;
}

/* Remove margin for the last item */
.input-item:last-child {
  margin-right: 0;
}




.jumlah {
  display: grid;
  grid-template-columns: repeat(2, 1fr); /* Use two columns */
  grid-gap: 20px; /* Increase gap for better spacing */
  margin-top: 20px; /* Add some margin */
}

.jumlah-container {
  border-radius: 10px;
  overflow: hidden;
  position: relative;
}


.responsive-image {
  width: 100%;
  height: auto;
  display: block;
}

.text-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-family: Arial, sans-serif;
  text-align: center; /* Centers the text horizontally */
}

.values-layered h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #150069;
  text-align: center;
}

.number {
  font-size: 24px;
  font-weight: bold;
  color: #a80000;
  text-align: center;
}

.campaign-section {
  margin-bottom: 30px;
}

.campaign-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr; 
  gap: 20px;
  margin-top: 10px;
}

.campaign-column {
  padding: 15px;
  border-radius: 10px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  text-align: center; 
  color: white;
}
.saran-kempen {
  background-color: #1db022; 
}

.pelaksanaan {
  background-color: #f4da47; 
}

.mencapai-sasaran {
  background-color: #e14949; 
}


.count {
  font-size: 24px;
  font-weight: bold;
  color: black;
  text-align: center;
}

@media (max-width: 1024px) {
  .jumlah {
    grid-template-columns: 1fr; /* Stack for smaller screens */
  }
  
  .campaign-row {
    grid-template-columns: 1fr 1fr; /* 2 columns for medium screens */
  }

  h2 {
    font-size: 1.3rem;
  }
}

@media (max-width: 768px) {
  .input-row {
    flex-direction: column;
    align-items: stretch;
  }

  .campaign-row {
    grid-template-columns: 1fr; /* Stack columns for smaller screens */
  }

  h2 {
    font-size: 1.2rem;
  }

  .count {
    font-size: 22px;
  }
}

@media (max-width: 480px) {
  .content-wrapper {
    padding: 10px;
  }

  .image-wrapper {
    margin-block-end: 10px;
  }

  .pbt-image {
    max-width: 90%;
  }

  .line-under-image {
    width: 90%;
  }

  .jumlah {
    grid-template-columns: 1fr; /* Single column for mobile */
  }

  .input-row {
    flex-direction: column;
  }

  h2 {
    font-size: 1rem;
    margin-top: 20px;
    margin-bottom: 5px;
  }

  h3, h4 {
    font-size: 0.9rem;
  }

  .campaign-section {
    margin-bottom: 20px;
  }

  .count {
    font-size: 20px;
  }
}
</style>
